import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'common/components/Intl';
import { configureLocales } from 'common/locales';
import { AgeGateContext } from './ageGateContext';
import Cookie from 'js-cookie';
import Api from 'api/ApiClient';

import AgeGateModalContainer from 'apps/age_gate/containers/AgeGateModalContainer';
import { AgeGateUIPolicy } from './AgeGateUIPolicy';
import { AgeGateTPActions } from './AgeGateTPActions';
import { messages } from './messages';

configureLocales(global.translations.locale);

export const mount = (rootElementId, configurations) => {
  const modifiedConfigs = {
    ...configurations,
    windowLocation: window.location,
    geolocation: global.gon.geo_location,
  };
  const ageGateUIPolicy = AgeGateUIPolicy(modifiedConfigs);
  const globalConfigs = {
    bugsnagClient: global.bugsnagClient,
    windowLocation: window.location,
    api: Api,
    cookie: Cookie,
  };
  const ageGateTPActions = AgeGateTPActions(globalConfigs);

  const messageKeys = messages(
    ageGateUIPolicy.isWarrantyAgeGate() ? 'warranty' : 'regular'
  );

  ReactDOM.render(
    <IntlProvider
      locale={global.translations.locale}
      messages={global.translations.messages}
    >
      <AgeGateContext.Provider
        value={{
          messageKeys,
          translationMessages: global.translations.messages,
        }}
      >
        <AgeGateModalContainer
          configurations={modifiedConfigs}
          ageGateUIPolicy={ageGateUIPolicy}
          ageGateTPActions={ageGateTPActions}
        />
      </AgeGateContext.Provider>
    </IntlProvider>,
    document.getElementById(rootElementId)
  );
};
